<div class="bl-page">

  <!-- ============== Filter bar ============== -->
  <div class="filter-bar">
    <div class="f-customer">
      <!-- type-ahead: click, then type part of the name or the company # -->
      <rms-search-select name="blCustomer" label="Customer" [options]="CustomerOptions"
                         labelKey="label" valueKey="value"
                         [(ngModel)]="CompanyID" (ngModelChange)="queueRefresh()" [disabled]="Loading"></rms-search-select>
    </div>
    <div class="f-burn">
      <rms-select name="blBurn" label="Burn range" [options]="BurnRangeOptions" [(ngModel)]="BurnRange" (ngModelChange)="queueRefresh()"
                  [disabled]="Loading"></rms-select>
    </div>
    <div class="f-wh">
      <rms-select name="blWh" label="Warehouse" [options]="WarehouseOptions" [(ngModel)]="WarehouseID" (ngModelChange)="queueRefresh()"
                  [disabled]="Loading"></rms-select>
    </div>
    <div class="f-bar">
      <rms-select name="blBarMonths" label="Bar shows" [options]="BarMonthOptions" [(ngModel)]="BarMonths" (ngModelChange)="queueRefresh()"
                  [disabled]="Loading"></rms-select>
    </div>
    <div class="f-checks">
      <rms-checkbox name="blShowAll" [small]="true" label="Show groups with no burn / reserves"
                    [(ngModel)]="ShowAll" (ngModelChange)="buildSections()"></rms-checkbox>
    </div>
    <div class="f-run">
      @if (FiltersChanged) {
      <span class="run-hint"><mat-icon>info</mat-icon>Updating automatically…</span>
      }
      <button mat-flat-button class="btn-bg-green" [class.run-pulse]="FiltersChanged" (click)="load()" [disabled]="Loading || !CompanyID">
        <mat-icon>play_arrow</mat-icon>{{ Loading ? 'Updating…' : 'Refresh' }}
      </button>
    </div>
  </div>

  @if (!Header) {
  <div class="empty">
    <mat-icon>coffee</mat-icon>
    <div>Pick a <b>customer</b>. Their coffee forecast opens automatically.</div>
    <div class="hint">Shows each coffee group's burn, reserves and how many bags to book to get to new crop.</div>
  </div>
  } @else {

  @if (Header.IsTestMode) {
  <div class="test-banner">
    <mat-icon>science</mat-icon>
    <span><b>Test mode</b> — burn is measured up to {{ Header.BurnWindowEnd | date:'MMM d, y':'UTC' }}. Reserves and RNY stock are as of today.</span>
  </div>
  }

  <!-- ============== Header band ============== -->
  <div class="band">
    <div class="band-left">
      <div class="band-name">{{ Header.CompanyName }} <span class="band-id">#{{ Header.CompanyID }}</span></div>
      <div class="band-sub">
        {{ Header.WarehouseName ?? 'No warehouse' }}{{ Header.WarehouseID === Header.DefaultWarehouseID ? ' (usual)' : '' }}
        · burn {{ Header.BurnRange }}-month average {{ Header.BurnWindowStart | date:'MMM d, y':'UTC' }} – {{ Header.BurnWindowEnd | date:'MMM d, y':'UTC' }}
        · {{ Header.GroupsShown }} groups{{ Header.GroupsHidden ? ' (' + Header.GroupsHidden + ' with no burn / reserves hidden)' : '' }}
      </div>
    </div>
    <div class="band-kpis">
      <div class="bk"><span>On reserve</span><b>{{ Header.TotalOnReserve | number:'1.0-0' }}</b></div>
      <div class="bk" [class.bk-alert]="TotalRecommended > 0"><span>Recommend booking</span><b>{{ TotalRecommended | number:'1.0-0' }}</b></div>
      <div class="bk" [class.bk-alert]="ShortCount > 0"><span>Not enough RNY stock</span><b>{{ ShortCount }}</b></div>
    </div>
  </div>

  @if (Header.Message) {
  <div class="message">{{ Header.Message }}</div>
  }
  @if (Header.UngroupedBags12 || Header.UngroupedReserve) {
  <div class="hint warn">
    @if (Header.UngroupedBags12) { {{ Header.UngroupedBags12 | number:'1.0-0' }} bags picked up }
    @if (Header.UngroupedBags12 && Header.UngroupedReserve) { and }
    @if (Header.UngroupedReserve) { {{ Header.UngroupedReserve | number:'1.0-0' }} bags on reserve }
    are on SKUs with no coffee group, so they are not in the rows below.
  </div>
  }

  <div class="live-banner" role="status">{{ Loading ? 'Updating…' : LivePaused ? 'Live refresh paused to protect your edits. Save or clear changes to update.' : 'Live · updates automatically' }} @if (UpdatedAt) { · {{ UpdatedAt | date:'h:mm:ss a' }} }</div>
  <section class="customer-notes"><h3>Customer notes</h3><div class="note-entry"><textarea aria-label="Customer note" [(ngModel)]="NoteText" placeholder="Add a trader note or customer suggestion"></textarea><label><input type="checkbox" [(ngModel)]="CustomerVisible" /> Customer visible</label><button mat-stroked-button (click)="addCustomerNote()" [disabled]="!NoteText.trim() || SavingNote">Save note</button><button mat-stroked-button (click)="emailDraft()"><mat-icon>mail</mat-icon>Draft customer email</button></div>
  @for (note of CustomerNotes; track note.NoteID) {<p><b>{{ note.IsCustomerVisible ? 'Customer suggestion' : 'Trader note' }}</b> · {{ note.InsertedDate | date:'MMM d, y' }}<br />{{ note.NoteText }}</p>}</section>
  <!-- ============== Actions ============== -->
  <div class="actions">
    <button mat-flat-button class="btn-bg-green" (click)="saveChanges()" [disabled]="Saving || !DirtyCount">
      <mat-icon>save</mat-icon>{{ Saving ? 'Saving…' : 'Save changes' + (DirtyCount ? ' (' + DirtyCount + ')' : '') }}
    </button>
    <button mat-stroked-button (click)="clearChanges()" [disabled]="!DirtyCount">
      <mat-icon>undo</mat-icon>Clear changes
    </button>
    <button mat-stroked-button (click)="saveSnapshot()" [disabled]="Saving">
      <mat-icon>bookmark_add</mat-icon>Save snapshot
    </button>
    <button mat-flat-button class="btn-bg-blue" (click)="makeProposal()" [disabled]="Generating || Saving">
      <mat-icon>picture_as_pdf</mat-icon>{{ Generating ? 'Making PDF…' : 'Purchase Proposal PDF' }}
    </button>
    <button mat-stroked-button (click)="exportCsv()">
      <mat-icon>download</mat-icon>Export CSV
    </button>
    <button mat-stroked-button (click)="togglePrintAll()" [disabled]="!Rows.length"
            [title]="AllPrinted ? 'Untick Print on every group, then tick only the ones you want' : 'Tick Print on every group'">
      <mat-icon>{{ AllPrinted ? 'check_box_outline_blank' : 'select_all' }}</mat-icon>
      {{ AllPrinted ? 'Unselect all' : 'Select all' }}
      <span class="print-count">({{ PrintCount }} to print)</span>
    </button>
    <span class="legend">
      <span><i class="sw ok"></i>Covered</span>
      <span><i class="sw low"></i>Less than a month left</span>
      <span><i class="sw neg"></i>Short</span>
      <span><i class="sw crop"></i>New-crop month</span>
      <span><i class="sw edited"></i>Changed, not saved</span>
    </span>
  </div>

  <!-- ============== Groups ============== -->
  <div class="grid-wrap">
    <table class="bl">
      <thead>
        <tr>
          <th class="c-name">Coffee group</th>
          <th>Burn / mo</th>
          <th>On reserve</th>
          <th>At roastery</th>
          <th>New crop</th>
          <th>Needed to crop</th>
          <th>Recommend</th>
          <th>RNY available</th>
          <th class="c-bar">Surplus / deficit by month</th>
          <th>Est. depletion</th>
          <th title="Show this group on the printed / PDF copy">Print</th>
          <th title="Customer accepted the recommendation">Accepted</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (sec of Sections; track sec.name) {
        <tr class="sec-row"><td colspan="13">{{ sec.name }}</td></tr>

        @for (r of sec.rows; track r.GroupID) {
        <tr class="g-row" [class.dirty]="isDirty(r)" [class.hidden-row]="r.src.IsHidden">
          <td class="c-name">
            <div class="g-name">{{ r.Name }}</div>
            @if (r.RecText) { <div class="g-rec" [class.g-rec-buy]="r.Recommended > 0">{{ r.RecText }}</div> }
            @if (r.Short) { <div class="g-short">Not enough inventory to cover your needs, please contact your Trader!</div> }
          </td>
          <td class="c-burn">
            <input type="number" min="0" step="0.1" class="cell-input" [(ngModel)]="r.burnOverride" (ngModelChange)="onEdit(r)"
                   [placeholder]="(r.src.BurnDefault | number:'1.0-1') ?? '0'"
                   title="Leave empty to use the customer's burn ({{ r.src.BurnDefault | number:'1.0-1' }})" />
            <div class="sub">3m {{ r.src.Burn3 | number:'1.0-0' }} · 6m {{ r.src.Burn6 | number:'1.0-0' }} · 12m {{ r.src.Burn12 | number:'1.0-0' }}</div>
          </td>
          <td>
            <b>{{ r.src.OnReserve | number:'1.0-0' }}</b>
            <div class="sub">{{ r.src.ReservedSpot | number:'1.0-0' }} spot · {{ r.src.ReservedForward | number:'1.0-0' }} fwd</div>
            @if (r.src.ContractThru) { <div class="sub">thru {{ d(r.src.ContractThru) | date:'MMM d, y' }}</div> }
          </td>
          <td>
            <input type="number" min="0" step="1" class="cell-input" [(ngModel)]="r.roastery" (ngModelChange)="onEdit(r)" placeholder="0" />
          </td>
          <td>
            {{ (d(r.src.Crop1Arrival) | date:'MMM d, y') ?? '—' }}
            @if (r.src.CropIsDefault) { <div class="sub" title="No crop data for these SKUs — legacy default Jan 15 next year">default date</div> }
          </td>
          <td>{{ r.Needed | number:'1.0-0' }}</td>
          <td class="c-rec" [class.c-rec-buy]="r.Recommended > 0">{{ r.Recommended | number:'1.0-0' }}</td>
          <td [class.c-short]="r.Short">
            {{ (r.src.RnySpotUnsold + r.src.RnyForwardUnsold) | number:'1.0-0' }}
            <div class="sub">{{ r.src.RnySpotUnsold | number:'1.0-0' }} spot · {{ r.src.RnyForwardUnsold | number:'1.0-0' }} fwd</div>
          </td>
          <td class="c-bar">
            <div class="bar">
              @for (b of r.Bars; track $index) {
              <span class="cell {{ barColor(b, r.BurnUsed) }}" [class.crop]="b.crop"
                    (click)="chooseCoverage(r, $index)" tabindex="0" role="button" (keydown.enter)="chooseCoverage(r, $index)" (keydown.space)="$event.preventDefault(); chooseCoverage(r, $index)" [attr.aria-label]="'Cover through ' + b.label" title="Click to cover through {{ b.label }}. {{ b.label }}: {{ b.value | number:'1.0-0' }} bags left{{ b.arriving ? ' · ' + (b.arriving | number:'1.0-0') + ' reserve bags arriving' : '' }}{{ b.crop ? ' · new crop' : '' }}"></span>
              }
            </div>
          </td>
          <td>
            {{ r.DepletionMonth ? m(r.DepletionMonth) : (r.BurnUsed > 0 ? 'beyond ' + r.Bars.length + ' mo' : '—') }}
            @if (r.MonthsCovered !== null) { <div class="sub">{{ r.MonthsCovered }} mo covered</div> }
          </td>
          <td class="c-chk"><input type="checkbox" [(ngModel)]="r.print" (ngModelChange)="onEdit(r)" /></td>
          <td class="c-chk"><input type="checkbox" [(ngModel)]="r.accepted" (ngModelChange)="onEdit(r)" /></td>
          <td class="c-tools">
            <button type="button" class="icon-btn" title="Reset to default" (click)="resetRow(r)"><mat-icon>restart_alt</mat-icon></button>
            <button type="button" class="icon-btn" [title]="r.expanded ? 'Hide SKUs' : 'Show SKUs and RNY stock by warehouse'"
                    (click)="r.expanded = !r.expanded">
              <mat-icon>{{ r.expanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </td>
        </tr>

        @if (r.expanded) {
        <tr class="detail-row">
          <td colspan="13">
            <div class="detail">
              <div class="d-block">
                <div class="d-title">SKUs — customer's first, then what RNY has unsold</div>
                <table class="mini">
                  <thead>
                    <tr>
                      <th>SKU</th>
                      <th>Customer's</th>
                      <th>Burn override</th><th>At roastery</th>
                      <th>Reserved spot</th>
                      <th>Reserved fwd</th>
                      <th>Contract thru</th>
                      <th>RNY spot</th>
                      <th>RNY fwd</th>
                      <th>Next arrival</th>
                      <th>Last pickup</th>
                    </tr>
                  </thead>
                  <tbody>
                    @for (s of r.Skus; track s.InventoryTypeID) {
                    <tr [class.not-cust]="!s.CustomerSku">
                      <td class="left">{{ s.InventoryTypeID }} {{ s.InventoryTypeName }}</td>
                      <td>{{ s.CustomerSku ? 'Yes' : '' }}</td>
                      <td><input type="number" min="0" step="0.01" class="cell-input" [attr.aria-label]="'Burn override SKU ' + s.InventoryTypeID" [(ngModel)]="s.burnOverride" (ngModelChange)="onEdit(r)" [placeholder]="(s.BurnDefault | number:'1.0-1') ?? '0'" /></td><td><input type="number" min="0" step="1" class="cell-input" [attr.aria-label]="'Roastery bags SKU ' + s.InventoryTypeID" [(ngModel)]="s.roastery" (ngModelChange)="onEdit(r)" placeholder="0" /></td>
                      <td>{{ s.ReservedSpot | number:'1.0-0' }}</td>
                      <td>{{ s.ReservedForward | number:'1.0-0' }}</td>
                      <td>{{ (s.ContractThru | date:'MMM d, y') ?? '' }}</td>
                      <td>{{ s.RnySpotUnsold | number:'1.0-0' }}</td>
                      <td>{{ s.RnyForwardUnsold | number:'1.0-0' }}</td>
                      <td>{{ (s.NextUnsoldArrival | date:'MMM d, y') ?? '' }}</td>
                      <td>{{ (s.LastPickup | date:'MMM d, y') ?? '' }}</td>
                    </tr>
                    } @empty {
                    <tr><td colspan="10" class="left muted">No SKUs.</td></tr>
                    }
                  </tbody>
                </table>
              </div>
              <div class="d-block d-wh">
                <div class="d-title">RNY unsold by warehouse</div>
                <table class="mini">
                  <thead><tr><th>Warehouse</th><th>Spot</th><th>Forward</th><th>Next arrival</th></tr></thead>
                  <tbody>
                    @for (w of r.ByWarehouse; track w.WarehouseID) {
                    <tr>
                      <td class="left">{{ w.WarehouseName }}</td>
                      <td>{{ w.SpotUnsold | number:'1.0-0' }}</td>
                      <td>{{ w.ForwardUnsold | number:'1.0-0' }}</td>
                      <td>{{ (w.NextUnsoldArrival | date:'MMM d, y') ?? '' }}</td>
                    </tr>
                    } @empty {
                    <tr><td colspan="4" class="left muted">RNY has nothing unsold in this group.</td></tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
          </td>
        </tr>
        }
        }
        } @empty {
        <tr><td colspan="13" class="left muted pad">No groups to show for this customer.</td></tr>
        }
      </tbody>
    </table>
  </div>
  }
</div>
